<template>
  <GenericStep v-bind="$attrs">
    <SiblingsCard
      v-for="sibling of peParty.siblings"
      :key="sibling.id"
      class="mb-4"
      :form-only="true"
      :item="sibling"
    />

    <SectionAdderLine
      section="Sibling"
      :has-new-section="peSiblingsCardHasNewSection"
      @on-add="peSiblingsCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'
import SiblingsCard from '@/components/Party/PartyEdit/SectionCards/FamiliesCards/SiblingsCard.vue'

export default {
  name: 'SiblingsStep',

  components: {
    GenericStep,
    SectionAdderLine,
    SiblingsCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.siblings
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
      'peSiblingsCardHasNewSection',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peSiblingsCardAddSection',
    ]),
  },
}
</script>
